import { InterestAccountDetailRequest, InterestAccruedDetail } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useFetchInterestAccruedHistory() {
  const [interestAccruedHistory, setInterestAccruedHistory] = useState<InterestAccruedDetail[]>([]);
  const [fetching, setFetching] = useState(false);

  async function fetchInterestAccruedHistory(request: InterestAccountDetailRequest = {}) {
    try {
      setFetching(true);
      const res = await api.fetchInterestAccountDetail(request);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      const sorted = res.InterestAccruedDetails.sort((a, b) => {
        const dateA = new Date(a.DateAccrued);
        const dateB = new Date(b.DateAccrued);

        return dateA.valueOf() - dateB.valueOf();
      });

      setInterestAccruedHistory(sorted);

      return sorted;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetching(false);
    }
  }

  return {
    fetchingInterestAccruedHistory: fetching,
    fetchInterestAccruedHistory,
    interestAccruedHistory,
  };
}
